import { HornsImage } from "./image-horns";
import { LogoWhiteImage } from "./image-logo-white";
import { WavingHandImage } from "./image-waving-hand";
import { NewCampaignImage } from "./image-new-campaign";
import { PaymentInfoImage } from "./image-payment-info";
import { PaymentInfoCompleteImage } from "./image-payment-info-complete";
import { PerksProgramImage } from "./image-perks-program";
import { BitcoinLogoImage } from "./image-bitcoin-logo";
import { CheckmarkImage } from "./image-checkmark";
import { RightArrowImage } from "./image-right-arrow";
import { FlagCanadaImage } from "./image-flag-canada";
import { AmazonLogoImage } from "./image-amazon-logo";
import { BlogImage } from "./image-blog";
import { ParachuteLogoImage } from "./image-parachute-logo";
import { BackgroundParachuteImage } from "./image-background-parachute";
import { ParachuteLogoWithTextImage } from "./image-parachute-logo-with-text";

type HighResolutionProps = {
  highResolution?: boolean;
};

type DynamicImageProps = { 
  imageType?: string 
};

type RectangularIconProps = {
  width?: number | string;
  height?: number | string;
} & HighResolutionProps & DynamicImageProps;


export type ImageVariantType =
  | "horns"
  | "logoWhite"
  | "wavingHand"
  | "voidCheque"
  | "paymentInfo"
  | "paymentInfoComplete"
  | "perksProgram"
  | "checkmark"
  | "bitcoinLogo"
  | "newCampaign"
  | "rightArrow"
  | "flagCanada"
  | "blog"
  | "amazonLogo"
  | "parachuteLogo"
  | "parachuteLogoWithText"
  | "backgroundParachute";

export type ImageProps =
  | ({ variant: "horns" } & RectangularIconProps)
  | ({ variant: "logoWhite" } & RectangularIconProps)
  | ({ variant: "wavingHand" } & RectangularIconProps)
  | ({ variant: "paymentInfo" } & RectangularIconProps)
  | ({ variant: "paymentInfoComplete" } & RectangularIconProps)
  | ({ variant: "perksProgram" } & RectangularIconProps)
  | ({ variant: "checkmark" } & RectangularIconProps)
  | ({ variant: "bitcoinLogo" } & RectangularIconProps)
  | ({ variant: "newCampaign" } & RectangularIconProps)
  | ({ variant: "rightArrow" } & RectangularIconProps)
  | ({ variant: "flagCanada" } & RectangularIconProps)
  | ({ variant: "blog" } & RectangularIconProps)
  | ({ variant: "amazonLogo" } & RectangularIconProps)
  | ({ variant: "parachuteLogo" } & RectangularIconProps)
  | ({ variant: "parachuteLogoWithText" } & RectangularIconProps)
  | ({ variant: "backgroundParachute" } & RectangularIconProps);

export const Image = (props: ImageProps): JSX.Element => {
  const { variant } = props;
  switch (variant) {
    case "horns":
      return <HornsImage {...props} />;
    case "blog":
      return <BlogImage {...props} />;
    case "logoWhite":
      return <LogoWhiteImage {...props} />;
    case "wavingHand":
      return <WavingHandImage {...props} />;
    case "paymentInfo":
      return <PaymentInfoImage {...props} />;
    case "paymentInfoComplete":
      return <PaymentInfoCompleteImage {...props} />;  
    case "perksProgram":
      return <PerksProgramImage {...props} />;      
    case "bitcoinLogo":
      return <BitcoinLogoImage {...props} />;
    case "checkmark":
      return <CheckmarkImage {...props} />;  
    case "newCampaign":
      return <NewCampaignImage {...props} />;
    case "rightArrow":
      return <RightArrowImage {...props} />;
    case "flagCanada":
      return <FlagCanadaImage {...props} />;
    case "amazonLogo":
      return <AmazonLogoImage {...props} />;         
    case "parachuteLogo":
      return <ParachuteLogoImage {...props} />;         
    case "parachuteLogoWithText":
      return <ParachuteLogoWithTextImage {...props} />;         
    case "backgroundParachute":
      return <BackgroundParachuteImage {...props} />;         
    default:
      throw new Error(`Invalid Image variant [${variant}] provided`);
  }
};
